import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Trust from "@/components/sections/Trust";
import Services from "@/components/sections/Services";
import Packages from "@/components/sections/Packages";
import Industries from "@/components/sections/Industries";
import Process from "@/components/sections/Process";
import Founder from "@/components/sections/Founder";
import Testimonials from "@/components/sections/Testimonials";
import CaseStudies from "@/components/sections/CaseStudies";
import Faq from "@/components/sections/Faq";
import Booking from "@/components/sections/Booking";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CursorGlow from "@/components/CursorGlow";

// Lazy-load heavier below-the-fold showcase sections to keep the initial bundle lean.
const AICalling = lazy(() => import("@/components/sections/AICalling"));
const WhatsAppShowcase = lazy(() => import("@/components/sections/WhatsAppShowcase"));
const EmailAutomation = lazy(() => import("@/components/sections/EmailAutomation"));
const Blog = lazy(() => import("@/components/sections/Blog"));

function SectionFallback() {
  return (
    <div className="section flex items-center justify-center" aria-hidden="true">
      <div className="dot-loader" />
    </div>
  );
}

export default function Home() {
  return (
    <main data-testid="home-page" className="relative">
      <CursorGlow />
      <Navbar />
      <Hero />
      <Trust />
      <Services />
      <Suspense fallback={<SectionFallback />}>
        <AICalling />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <WhatsAppShowcase />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <EmailAutomation />
      </Suspense>
      <Packages />
      <Industries />
      <Process />
      <CaseStudies />
      <Testimonials />
      <Founder />
      <Suspense fallback={<SectionFallback />}>
        <Blog />
      </Suspense>
      <Faq />
      <Booking />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
